import React from 'react';

import App from './App';
import './index.css';

// ReactDOM.render(<App />, document.getElementById('root'));

import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('root')).render(<App />);